import Vue from 'vue';
import Router from 'vue-router';
import multiguard from 'vue-router-multiguard';

import { IsNotAuthGuard } from '@/common/guards/isNotAuth.guard';
import { IsAuthGuard } from '@/common/guards/isAuth.guard';
import { IsSchoolGuard } from '@/common/guards/isSchool.guard';
import { IsStudentGuard } from '@/common/guards/isStudent.guard';
import { PageExistsGuard } from '@/common/guards/pageExistsGuard';
import { PagesLoaded } from '@/common/guards/pagesLoadedGuard';
import PageNotFound from '@/views/Error/PageNotFound';
import Page from '@/views/Page';
import RegisterAcknowledge from '@/views/Register/RegisterAcknowledge';
import RequestPricingAcknowledge from '@/views/RequestPricing/RequestPricingAcknowledge';
import TermsAndConditions from '@/views/TermsAndConditions'
import ContactUsAcknowledge from '@/views/ContactUs/ContactUsAcknowledge';
import ErrorPage from '@/views/Error/ErrorPage';
import { CategoryArticlesLoaded } from '@/common/guards/categoryArticlesLoaded.guard';
import { CategoriesLoaded } from '@/common/guards/categoriesLoaded.guard';
import { CategoryLoaded } from '@/common/guards/categoryLoaded.guard';
import { ArticleViewed } from "@/common/guards/articleViewed.guard";
import { CarouselSlidesLoaded } from '@/common/guards/carouselSlidesLoaded.guard';
import InvalidSubscription from '@/views/Error/InvalidSubscription';
import { ArticleSelectedGuard } from '@/common/guards/articleSelected.guard';
import { HasAcceptedTermsGuard } from "@/common/guards/acceptedTerms.guard";
import { UsingDefaultPasswordGuard } from "@/common/guards/usingDefaultPassword.guard";
import { UserLoadedGuard } from "@/common/guards/userLoaded.guard";

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior: function () {
    return  {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '',
      name: 'home',
      component: () => import('@/views/Home'),
      beforeEnter: multiguard([IsNotAuthGuard, PagesLoaded, CarouselSlidesLoaded])
    },
    {
      path: '/home',
      redirect: {name: 'home'}
    },
    {
      path: '/auth/:hash',
      name: 'auth',
      component: () => import('@/views/Auth'),
      beforeEnter: multiguard([IsNotAuthGuard])
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/Register'),
      beforeEnter: multiguard([IsNotAuthGuard, PagesLoaded])
    },
    {
      path: '/reset-password/:token',
      name: 'reset-password',
      component: () => import('@/views/ResetPassword'),
      beforeEnter: multiguard([PagesLoaded])
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/ForgotPassword'),
      beforeEnter: multiguard([PagesLoaded])
    },
    {
      path: '/pricing',
      name: 'requestPricing',
      component: () => import('@/views/RequestPricing'),
      beforeEnter: multiguard([PagesLoaded])
    },
    {
      path: '/user/update-password',
      name: 'update-user-password',
      component: () => import('@/views/User/Update-Password'),
      beforeEnter: multiguard([IsAuthGuard, UserLoadedGuard])
    },
    {
      path: '/admin',
      component: () => import('@/views/Admin'),
      beforeEnter: multiguard([IsAuthGuard, IsSchoolGuard, UserLoadedGuard, UsingDefaultPasswordGuard, HasAcceptedTermsGuard, PagesLoaded]),
      children: [
        {
          path: '',
          name: 'admin',
          component: () => import('@/views/Admin/Admin')
        },
        {
          path: 'reports',
          name: 'reports',
          component: () => import('@/views/Admin/Reports')
        },
        {
          path: 'resources',
          name: 'resources',
          component: () => import('@/views/Admin/Resources')
        }
      ]
    },
    {
      path: '/student',
      component: () => import('@/views/Student'),
      beforeEnter: multiguard([IsAuthGuard, IsStudentGuard, UserLoadedGuard, CategoriesLoaded]),
      children: [
          {
              path: '',
              name: 'student',
              component: () => import('@/views/Student/Feature')
          },
          {
            path: 'search-results',
            exact: true,
            name: 'searchResults',
            component: () => import('@/views/Student/SearchResults')
          },
          {
              path: ':category',
              name: 'category',
              component: () => import('@/views/Student/Category'),
              beforeEnter: (to, from, next) => CategoryArticlesLoaded(to, from, next),
          },
          {
              path: ':category/:article',
              name: 'article',
              component: () => import('@/views/Student/Article'),
              beforeEnter: multiguard([CategoryLoaded, ArticleSelectedGuard, ArticleViewed]),
          }
      ]
    },
    {
      path: '/pricing/acknowledge',
      name: 'pricing-acknowledge',
      component: RequestPricingAcknowledge
    },
    {
      path: '/register/acknowledge',
      name: 'register-acknowledge',
      component: RegisterAcknowledge
    },
    {
      path: '/terms-and-conditions',
      name: 'terms',
      component: TermsAndConditions,
      beforeEnter: multiguard([IsAuthGuard, IsSchoolGuard, UserLoadedGuard, PagesLoaded])
    },
    {
      name: 'error',
      path: '/error',
      component: ErrorPage
    },
    {
      name: 'invalid-subscription',
      path: '/invalid-subscription',
      component: InvalidSubscription
    },
    {
      path: '/:page',
      name: 'page',
      component: Page,
      beforeEnter: multiguard([PagesLoaded, PageExistsGuard])
    },
    {
      path: '/contact-us/acknowledge',
      name: 'contact-us-acknowledge',
      component: ContactUsAcknowledge
    },
    {
      path: '*',
      redirect: {name: '404'}
    },
    {
      path: '/page-not-found',
      name: '404',
      component: PageNotFound
    }
  ]
});
